import contractApi from '@/api/contract';

export default {
  namespaced: true,
  state: {
    data: []
  },
  getters: {
    findContracts(state, getters, rootState) {
      return (type, coin = 'BTC') => {
        const iter = typeof type === 'string' ? v => v.type === type && v.payoffType.indexOf(coin) >= 0 : type;
        return state.data.filter(iter).map(p => contractApi[p.issuer].getFullData(p, coin, rootState.blockchain));
      };
    },
    getContractById(state, getters, rootState) {
      return (id, coin = 'BTC') => {
        const product = state.data.find(p => p.id === id);
        if (product) return contractApi[product.issuer].getFullData(product, coin, rootState.blockchain);
      };
    }
  },
  mutations: {
    setData(state, data) {
      state.data = data;
    }
  },
  actions: {
    async load({ commit }) {
      commit('setData',  [
        ...await contractApi.nicehash.list(),
        ...await contractApi.lifetime.list(),
        ...await contractApi.ftx.list()
      ]);
    }
  }
};